import React from "react";
import { CalendarOutlined } from "@ant-design/icons";
import { Tag } from "antd";

const ValidatedAge = () => {
  return (
    <Tag icon={<CalendarOutlined />} color="success">
      <span style={{ color: "#393b4a" }}>Age Validated</span>
    </Tag>
  );
  // return <div className="validated-tag">Age Validated</div>;
};

export default ValidatedAge;
